const defaultButtonClasses =
  "inline-flex items-center justify-center h-10 w-10 border border-border " +
  "rounded-full bg-white font-secondary text-base text-subtle cursor-pointer " +
  "transition-[border-color,color,background-color] duration-150 " +
  "hover:not-disabled:border-primary hover:not-disabled:text-primary " +
  "hover:not-disabled:bg-primary/[0.08] " +
  "disabled:cursor-not-allowed disabled:opacity-60";

const defaultActiveClasses = "border-primary! text-primary! bg-primary/[0.08]!";

const DemandStudioHeaderButton = ({
  onClick,
  icon,
  label,
  ariaLabel,
  disabled = false,
  isActive = false,
  className = defaultButtonClasses,
  activeClassName = defaultActiveClasses,
}) => {
  const buttonLabel = ariaLabel || label;
  const finalClassName = isActive ? `${className} ${activeClassName}` : className;

  return (
    <button
      type="button"
      className={finalClassName.trim()}
      onClick={onClick}
      disabled={disabled}
      aria-label={buttonLabel}
      title={buttonLabel}
    >
      {icon && <i className={icon} />}
      {label}
    </button>
  );
};

export default DemandStudioHeaderButton;
